<template>
  <main-algolia
    :banners="banners"
    :is-active="isActive"
    :no-results-collection="noResultsCollection"
    is-search
  />
</template>

<script>

/**
 * Vue: Algolia search drawer (algolia-search-drawer)
 * -----------------------------------------------------------------------------
 * Algolia instant search.
 *
 */

import MainAlgolia from '~async/main-algolia/main-algolia'

export default {
  name: 'AlgoliaSearchDrawer',

  components: { MainAlgolia },

  props: {
    banners: {
      type: Array,
      default: () => [],
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    noResultsCollection: {
      type: Object,
      default: () => null,
    },
  },

  watch: {

    /**
     * Watch if search drawer is active.
     * Remove query from URL on close
     */
    isActive() {
      this.headerActiveToggle()

      if (this.isActive) {
        return
      }

      const params = new URLSearchParams(location.search)
      params.delete('q')

      let url = `${location.origin}${location.pathname}`

      if (params.toString()) {
        url += `?${params.toString()}`
      }

      history.replaceState({
        html: '',
      }, '', url)
    },
  },

  mounted() {
    this.headerActiveToggle()
  },

  methods: {

    /**
     * Toggle header container active class.
     */
    headerActiveToggle() {
      const header = document.getElementById('site-header-group-section')

      if (this.isActive) {
        header.classList.add(this.$class('active'))
      } else {
        setTimeout(() => {
          header.classList.remove(this.$class('active'))
        }, this.$timing('normal'))
      }
    },
  },
}
</script>

<style lang="scss">
@import './algolia-search-drawer';
</style>
